import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { whatsappUrl } from '@/content/site';
import { LanguageSwitcher } from './LanguageSwitcher';
import { WhatsAppIcon } from './Icons';
import styles from './Navbar.module.css';

export function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const links = [
    { href: '#servicios', label: t('nav.services') },
    { href: '#enfoque', label: t('nav.about') },
    { href: '#contacto', label: t('nav.contact') },
  ];

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <nav className={`container ${styles.nav}`} aria-label="Principal">
        <a href="#inicio" className={styles.brand}>
          <img src="/img/logo.svg" alt="" width={36} height={36} />
          <span>Psicointegralis</span>
        </a>

        <button
          type="button"
          className={styles.burger}
          aria-expanded={open}
          aria-controls="nav-menu"
          onClick={() => {
            setOpen((v) => !v);
          }}
        >
          <span className="visually-hidden">{t('nav.services')}</span>
          <span className={styles.burgerBox} data-open={open} aria-hidden>
            <span />
            <span />
            <span />
          </span>
        </button>

        <div id="nav-menu" className={styles.menu} data-open={open}>
          <ul className={styles.links}>
            {links.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <div className={styles.actions}>
            <LanguageSwitcher />
            <a
              className="btn btn--primary"
              href={whatsappUrl(t('hero.whatsappMessage'))}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon width={18} height={18} />
              {t('nav.cta')}
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
